// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"ff71367a287892f8ad895713257ed90e9aaf1c65"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/storefront/ff71367a287892f8ad895713257ed90e9aaf1c65";import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';

import { filterSentrySpan } from '@utils/sentryFilters';
import { tagBotTraffic } from '@utils/sentryTags';

const envVars = getConfig().publicRuntimeConfig;

Sentry.init({
  dsn: envVars.SENTRY_DSN || '',
  release: envVars.SENTRY_RELEASE || '',
  tracesSampleRate: 0.05,
  debug: false,
  denyUrls: [/inject_content\.js/],
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['storefront'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  beforeSendSpan: filterSentrySpan,
});

tagBotTraffic(navigator.userAgent);
